import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {ApprovedService} from './approved-service.model';
import {ServiceInstitutionFilter} from "../service/service.model";

export const loadApprovedServices = createAction(
  '[ApprovedService/API] Load ApprovedServices',
  props<{ approvedServices: ApprovedService[] }>()
);

export const addApprovedService = createAction(
  '[ApprovedService/API] Add ApprovedService',
  props<{ approvedService: ApprovedService }>()
);

export const upsertApprovedService = createAction(
  '[ApprovedService/API] Upsert ApprovedService',
  props<{ approvedService: ApprovedService }>()
);

export const addApprovedServices = createAction(
  '[ApprovedService/API] Add ApprovedServices',
  props<{ approvedServices: ApprovedService[] }>()
);

export const upsertApprovedServices = createAction(
  '[ApprovedService/API] Upsert ApprovedServices',
  props<{ approvedServices: ApprovedService[] }>()
);

export const updateApprovedService = createAction(
  '[ApprovedService/API] Update ApprovedService',
  props<{ approvedService: Update<ApprovedService> }>()
);

export const updateApprovedServices = createAction(
  '[ApprovedService/API] Update ApprovedServices',
  props<{ approvedServices: Update<ApprovedService>[] }>()
);

export const deleteApprovedService = createAction(
  '[ApprovedService/API] Delete ApprovedService',
  props<{ id: string }>()
);

export const deleteApprovedServices = createAction(
  '[ApprovedService/API] Delete ApprovedServices',
  props<{ ids: string[] }>()
);

export const clearApprovedServices = createAction(
  '[ApprovedService/API] Clear ApprovedServices'
);

// CUSTOM
export const getAllApprovedServices = createAction(
  '[ApprovedService/API] get all ApprovedServices',
  props<{ filtering?: ServiceInstitutionFilter }>()
);
